<template>
  <div>
    <v-skeleton-loader type="container" :loading="initLoading">
      <v-card>
        <v-card-title>
          <span class="black--text">{{ $vuetify.lang.t('$vuetify.label.please_register') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-row dense>
              <v-col cols="12" sm="12" md="7" lg="7">
                <v-text-field
                  v-model="entity.name"
                  color="secondary"
                  :disabled="loading"
                  :title="$vuetify.lang.t('$vuetify.label.name')"
                  :error-messages="nameErrors"
                  :counter="60"
                  :label="$vuetify.lang.t('$vuetify.label.name')"
                  @blur="$v.entity.name.$touch()"
                />
              </v-col>
              <v-col cols="12" sm="12" md="5" lg="5">
                <v-text-field
                  v-model="entity.cpf"
                  v-mask="'###.###.###-##'"
                  color="secondary"
                  :disabled="loading"
                  :title="$vuetify.lang.t('$vuetify.label.cpf')"
                  :error-messages="cpfErrors"
                  :counter="14"
                  :label="$vuetify.lang.t('$vuetify.label.cpf')"
                  @blur="$v.entity.cpf.$touch()"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="12" md="7" lg="7">
                <v-select
                  v-model="entity.gender"
                  :items="itemsGender"
                  item-value="code"
                  item-text="value"
                  color="secondary"
                  :disabled="loading"
                  clearable
                  :title="$vuetify.lang.t('$vuetify.title.patient.gender')"
                  :error-messages="genderErrors"
                  persistent-hint
                  :label="$vuetify.lang.t('$vuetify.label.gender')"
                  @blur="$v.entity.gender.$touch()"
                />
              </v-col>
              <v-col cols="12" sm="12" md="5" lg="5">
                <v-text-field
                  v-model="entity.birth_date"
                  v-mask="'##/##/####'"
                  :error-messages="birth_dateErrors"
                  color="secondary"
                  :disabled="loading"
                  :label="$vuetify.lang.t('$vuetify.label.birth_date')"
                  :title="$vuetify.lang.t('$vuetify.title.patient.birth_date')"
                  @change="date = parseDate(entity.birth_date)"
                  @input="$v.entity.birth_date.$touch()"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="12" md="12" lg="12">
                <dav-cellphone
                  id="dav_signup_cellphone"
                  ref="cell_phone"
                  v-model="entity.cell_phone"
                  is-mobile
                  :disabled="loading"
                  :country-list="domainCountryList"
                  required
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-text-field
                  v-model.trim="entity.mail"
                  color="secondary"
                  :disabled="loading"
                  :title="$vuetify.lang.t('$vuetify.title.patient.mail')"
                  :error-messages="mailErrors"
                  :label="$vuetify.lang.t('$vuetify.label.mail')"
                  @keydown.space.prevent
                  @input="
                    entity.mail = entity.mail.toLowerCase();
                    $v.entity.mail.$touch();
                  "
                />
              </v-col>
            </v-row>
            <v-row v-if="termSign && termSign.length > 0" dense>
              <v-spacer />
              <dav-accept-term
                ref="acceptTerm"
                :term-use="termSign"
                :loading="loading"
                :cancel-option="true"
                is-mobile
                :action-title="$vuetify.lang.t('$vuetify.btn.register_signin')"
                custom-url-accept
                @cancel="cancel()"
              />
            </v-row>
            <v-row v-else>
              <v-btn :disabled="loading" class="ml-3" @click="cancel()">
                {{ $vuetify.lang.t('$vuetify.btn.cancel') }}
              </v-btn>

              <v-spacer />

              <v-btn
                class="mr-3"
                color="primary"
                :loading="loading"
                :title="$vuetify.lang.t('$vuetify.btn.sign_up')"
                @click="register()"
              >
                {{ $vuetify.lang.t('$vuetify.btn.sign_up') }}
              </v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-skeleton-loader>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { email, maxLength, minLength, required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { load } from 'recaptcha-v3';
import validate from '../../../utils/validate';

export default {
  name: 'SignUp',
  mixins: [validate, validationMixin],
  props: {
    init: Boolean,
  },
  validations: {
    entity: {
      name: { required, maxLength: maxLength(60) },
      cpf: {
        minLength: minLength(14),
        maxLength: maxLength(14),
        required,
      },
      birth_date: { required },
      gender: { required },
      mail: { email, required },
    },
  },

  data: () => ({
    loading: false,
    initLoading: true,
    valid: true,
    clearable: true,
    location: undefined,
    domainCountryList: undefined,
    entity: {
      name: undefined,
      mail: undefined,
      cpf: undefined,
      gender: undefined,
      cell_phone: undefined,
      birth_date: undefined,
      term: undefined,
    },
    itemsGender: [
      {
        value: 'Feminino',
        code: 'F',
      },
      {
        value: 'Masculino',
        code: 'M',
      },
      {
        value: 'Outros',
        code: 'O',
      },
      {
        value: 'Prefiro não dizer',
        code: 'U',
      },
    ],
    status: true,
    menu: false,
    date: moment().format('YYYY-MM-DD'),
    tokenCaptcha: undefined,
    recaptchaLogin: undefined,
  }),

  computed: {
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    termSign() {
      return this.$store.getters['patient/GET_SIGNTERM'];
    },
    signData() {
      return this.$store.getters['patient/GET_SIGNDATA'];
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    feedback() {
      return this.$store.getters['common/FEEDBACK'];
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.entity.name.$dirty) return errors;
      !this.$v.entity.name.maxLength &&
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.maxLength', [this.$vuetify.lang.t('$vuetify.label.name')], [60])
        );
      !this.$v.entity.name.required &&
        errors.push(this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.name')]));
      return errors;
    },
    cpfErrors() {
      const errors = [];
      if (!this.$v.entity.cpf.$dirty) return errors;
      !this.$v.entity.cpf.minLength &&
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.minLength', [this.$vuetify.lang.t('$vuetify.label.cpf')], [14])
        );
      !this.$v.entity.cpf.maxLength &&
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.maxLength', [this.$vuetify.lang.t('$vuetify.label.cpf')], [14])
        );
      !this.$v.entity.cpf.required &&
        errors.push(this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.cpf')]));
      !this.validCpf(this.entity.cpf) &&
        errors.push(this.$vuetify.lang.t('$vuetify.message.isValid', [this.$vuetify.lang.t('$vuetify.label.cpf')]));
      return errors;
    },
    birth_dateErrors() {
      const errors = [];
      if (!this.$v.entity.birth_date.$dirty) return errors;
      !this.$v.entity.birth_date.required &&
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.birth_date')])
        );
      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.entity.gender.$dirty) return errors;
      !this.$v.entity.gender.required &&
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.gender')])
        );
      return errors;
    },
    mailErrors() {
      const errors = [];
      if (!this.$v.entity.mail.$dirty) return errors;
      !this.$v.entity.mail.required &&
        errors.push(this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.mail')]));
      !this.$v.entity.mail.email && errors.push(this.$vuetify.lang.t('$vuetify.message.invalidMail'));
      return errors;
    },
  },
  watch: {
    init(val) {
      if (val) {
        this.initRegister();
      }
    },
    signData(val) {
      if (val?.code === 200) {
        this.domainCountryList = val.data.countries;
      }
    },
    date() {
      this.entity.birth_date = this.formatDate(this.date);
    },
    termSign(val) {
      if (val && val.length > 0) this.askLocation();
    },
    feedback(value) {
      if (this.recaptchaLogin !== 'not_applied') {
        this.recaptchaLogin.hideBadge();
      }

      if (value?.code && value.code === 200) {
        this.cancel();
        this.$root.$emit('show-snackbar', { text: value.message, timeout: 4000, btnClose: false, color: 'success' });
        setTimeout(() => {
          this.loading = false;
        }, 4000);
        return;
      }

      if ('messages' in value) {
        const errors = JSON.parse(JSON.stringify(value.messages));

        this.$root.$emit('show-snackbar-multiple', errors);
        this.loading = false;
        this.valid = true;
        return;
      }

      this.$root.$emit('show-snackbar', { text: value.message, timeout: 0, btnClose: true, color: 'error' });
      this.loading = false;
      this.valid = true;
    },
  },
  async created() {
    const host = window.location.host;
    this.recaptchaLogin = 'not_applied';

    if (host.includes('dav.med.br')) {
      this.recaptchaLogin = await load('6Ld7-tgUAAAAANsiQUUrksoK0qtdxzTiU0sc9-CO', {
        useRecaptchaNet: true,
        autoHideBadge: true,
      });
    }

    if (this.init) {
      this.initRegister();

      this.$root.$on('fetchTermAccept', () => {
        return this.register();
      });
    }
  },
  methods: {
    askLocation() {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      window.navigator.geolocation.getCurrentPosition(this.setLocation, undefined, options);
    },
    setLocation(position) {
      if (position) {
        const coordinates = position.coords;
        if (coordinates) {
          this.location = {
            latitude: coordinates.latitude,
            longitude: coordinates.longitude,
          };
        }
      }
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format('DD/MM/YYYY');
    },
    parseDate(date) {
      const newDate = moment(date, 'DD-MM-YYYY');
      if (moment(newDate).isValid()) {
        return moment(newDate).format('YYYY-MM-DD');
      }

      if (moment(newDate) >= moment()) {
        this.entity.birth_date = null;
        return this.entity.birth_date;
      }

      this.entity.birth_date = null;
      return this.entity.birth_date;
    },
    async initRegister() {
      this.initLoading = true;
      const params = { company_id: this.setup.companyId };
      await Promise.allSettled([
        this.$store.dispatch('patient/FETCH_GET_SIGN', params),
        this.$store.dispatch('patient/FETCH_SIGN_TERM', params),
      ]);
      await this.resetRegistrarionFields();
      this.initLoading = false;
    },
    async register() {
      this.loading = true;
      try {
        if (this.recaptchaLogin === 'not_applied') {
          this.tokenCaptcha = 'not_applied';
        } else {
          this.tokenCaptcha = await this.recaptchaLogin.execute('login');
        }

        await this.validateRegistrationForm();
        if (this.$v.$invalid || this.$refs.cell_phone.$v.$invalid) {
          this.loading = false;
          return;
        }

        return this.new(this.tokenCaptcha);
      } catch {
        //
      }

      this.resetRegistrarionFields();
      this.loading = false;
      this.$root.$emit('person-sign-close', true);
    },
    async new(token) {
      const vm = this;
      if (!vm.$v.$invalid && !vm.$refs.cell_phone.$v.$invalid) {
        vm.valid = false;

        const entityToSave = JSON.parse(JSON.stringify(vm.entity));
        entityToSave.cpf = this.unmaskText(entityToSave.cpf);

        if (entityToSave.cell_phone?.number) {
          entityToSave.cell_phone_ddi = entityToSave.cell_phone.ddi;
          entityToSave.cell_phone = this.unmaskText(entityToSave.cell_phone.number);
        } else {
          delete entityToSave.cell_phone;
        }

        entityToSave.recaptchaToken = token;
        entityToSave.birth_date = moment(entityToSave.birth_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        entityToSave.company_id = this.setup.companyId;

        if (this.termSign && this.termSign.length > 0) {
          entityToSave.term = this.termSign;
        }

        if (this.location) {
          entityToSave.location = this.location;
        }

        await this.$store.dispatch('patient/FETCH_SIGN', entityToSave);

        this.valid = true;
        if (this.recaptchaLogin !== 'not_applied') {
          this.recaptchaLogin.hideBadge();
        }
      }
    },
    async validateRegistrationForm() {
      await this.$refs.cell_phone.validate();
      await this.$v.$touch();
    },
    cancel() {
      this.entity.name = null;
      this.entity.cpf = null;
      this.entity.gender = null;
      this.entity.birth_date = null;
      this.entity.mail = null;
      this.entity.cell_phone = null;
      if (this.recaptchaLogin !== 'not_applied') {
        this.recaptchaLogin.hideBadge();
      }
      this.resetRegistrarionFields();
      this.$root.$emit('person-sign-close', true);
    },
    resetRegistrarionFields() {
      if (this.termSign && this.$refs.acceptTerm) {
        this.$refs.acceptTerm.reset();
      }
      this.$v.entity.$reset();
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 0px);
}

@media only screen and (min-width: 600px) {
  .v-snack__wrapper {
    width: 100%;
  }
}
</style>
